import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Loader2 } from "lucide-react";
import { api, brl, fmtDateTime } from "@/lib/api";
import { STATUS_LABEL } from "@/lib/content";

const BADGE = { aguardando_precificacao: "border-amber-600 text-amber-400", aguardando_aceite: "border-sky-600 text-sky-400", aceita: "border-green-600 text-green-400", em_execucao: "border-red-600 text-red-400", concluida: "border-slate-500 text-slate-300", cancelada: "border-slate-700 text-slate-500" };

export const StatusBadge = ({ s }) => <span className={`whitespace-nowrap border px-2 py-0.5 font-mono text-[10px] uppercase ${BADGE[s]}`}>{STATUS_LABEL[s]}</span>;

export const AdminOSList = () => {
  const [list, setList] = useState(null);
  const [status, setStatus] = useState("");
  useEffect(() => {
    setList(null);
    api.get("/admin/os", { params: status ? { status } : {} }).then((r) => setList(r.data));
  }, [status]);
  return (
    <div className="card-tech p-4 sm:p-6" data-testid="admin-os-list">
      <div className="mb-4 flex flex-wrap items-center justify-between gap-3">
        <p className="font-heading text-lg font-bold uppercase text-white">Ordens de serviço</p>
        <select className="field !w-auto" value={status} onChange={(e) => setStatus(e.target.value)} data-testid="admin-os-filter">
          <option value="">Todos os status</option>
          {Object.entries(STATUS_LABEL).map(([k, v]) => <option key={k} value={k}>{v}</option>)}
        </select>
      </div>
      {!list ? <Loader2 className="mx-auto h-6 w-6 animate-spin text-red-500" /> : list.length === 0 ? (
        <p className="py-10 text-center text-sm text-slate-500">Nenhuma ordem de serviço.</p>
      ) : (
        <div className="overflow-x-auto">
          <table className="w-full min-w-[760px] text-sm">
            <thead><tr className="border-b border-slate-700 text-left font-mono text-[10px] uppercase tracking-wider text-slate-500">
              <th className="p-2">OS</th><th className="p-2">Emissão</th><th className="p-2">Cliente</th><th className="p-2">Veículo</th><th className="p-2">Cidade</th><th className="p-2">Total</th><th className="p-2">Status</th>
            </tr></thead>
            <tbody>{list.map((o) => (
              <tr key={o.id} className="border-b border-slate-800 transition-colors hover:bg-[#161E2E]">
                <td className="p-2"><Link to={`/admin/os/${o.id}`} className="font-mono font-bold text-red-400 hover:text-red-300" data-testid={`admin-os-row-${o.numero}`}>{o.numero}</Link></td>
                <td className="p-2 text-slate-400">{fmtDateTime(o.data_emissao)}</td>
                <td className="p-2 text-slate-200">{o.cliente.nome}<span className="block text-xs text-slate-500">{o.cliente.telefone}</span></td>
                <td className="p-2 text-slate-300">{o.veiculo.marca} {o.veiculo.modelo}</td>
                <td className="p-2 text-slate-400">{o.cliente.cidade}/{o.cliente.estado}</td>
                <td className="p-2 font-mono text-slate-200">{brl(o.valores.total)}</td>
                <td className="p-2"><StatusBadge s={o.status} /></td>
              </tr>))}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
};
